<authority-labs-base-dialog
  size="large"
  [dialogRef]="dialogRef"
  [title]="title"
  [isDirty]="isDirty"
>
  <button header nz-button nzType="text" class="white" (click)="hide()">
    <i nz-icon nzType="minus"></i>
  </button>

  <authority-labs-certificate
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="isDesignOrInstallationType"
  ></authority-labs-certificate>

  <authority-labs-certificate-water-network
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="isWaterNetworkType"
  ></authority-labs-certificate-water-network>

  <authority-labs-certificate-gas-extinguishing-system
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="isGasExtinguishingSystemType"
  ></authority-labs-certificate-gas-extinguishing-system>

  <authority-labs-certificate-fire-taps
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="isFireTapsType"
  ></authority-labs-certificate-fire-taps>

  <authority-labs-certificate-fire-extinguishers
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="isFireExtinguishersType"
  ></authority-labs-certificate-fire-extinguishers>

  <authority-labs-certificate-aerosol-shutdown
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="isAerosolShutdownType"
  ></authority-labs-certificate-aerosol-shutdown>

  <authority-labs-certificate-fire-alarm-system
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="isFireAlarmType"
  ></authority-labs-certificate-fire-alarm-system>

  <authority-labs-certificate-air-conditioning-and-ventilation-systems
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="isAirConditioninType"
  ></authority-labs-certificate-air-conditioning-and-ventilation-systems>

  <authority-labs-certificate-ventilation-system-and-fire-protection
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="isVentilationSystemAndFireProtectionType"
  ></authority-labs-certificate-ventilation-system-and-fire-protection>

  <authority-labs-certificate-pressure-system-in-stairwells-compatibility-check
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    *ngIf="IsPressureSystemInStairwellsCompatibilityCheckType"
  ></authority-labs-certificate-pressure-system-in-stairwells-compatibility-check>

  <authority-labs-certificate-integration
    content
    [order]="data.order"
    [inspection]="data.inspection"
    [planner]="data.planner"
    [contractor]="data.contractor"
    [project]="data.project"
    [subProject]="data.subProject"
    [company]="data.company"
    [contact]="data.contact"
    [assignee]="assignee"
    [approval]="approval"
    [apiUrl]="apiUrl"
    *ngIf="isIntegration"
  ></authority-labs-certificate-integration>

  <nz-space actions *ngIf="!data.readonly">
    <ng-template nzSpaceItem>
      <ng-container
        *ngIf="
        order?.sharePoint?.certificateId &&
        order?.sharePoint?.certificateId?.[order.version]
      "
      >
        <button nz-button nzType="primary" (click)="openPDF()">
          <span nz-icon nzType="download"></span>
          הורד מסמך
        </button>
      </ng-container>
    </ng-template>
    <ng-template [authorityLabsHasPermission]="editPermissions">
      <ng-template nzSpaceItem>
        <ng-container
          *ngIf="
            !(isFixedBefore || isFixingOrder || isClosedOrder || !isApproved)
          "
        >
          <button
            nz-button
            [nzLoading]="submitting"
            (click)="createPDF()"
            *ngIf="!isDirty"
          >
            <span nz-icon nzType="file-add"></span>
            הפק מסמך
          </button>
        </ng-container>
      </ng-template>
      <ng-template nzSpaceItem>
        <ng-container *ngIf="isFixingOrder && isApproved">
          <button
            nz-button
            [nzLoading]="submitting"
            (click)="createFixedPDF()"
            *ngIf="!isDirty"
          >
            יצירת תעודה מתקנת
          </button>
        </ng-container>
      </ng-template>
    </ng-template>
    <ng-template nzSpaceItem>
      <nz-upload
        nzListType="text"
        [nzShowUploadList]="false"
        [nzBeforeUpload]="beforeCertificateUpload"
        [nzAccept]="
          'application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/pdf'
        "
        (nzChange)="handleChange($event)"
      >
        <button nz-button>
          <span
            nz-icon
            [nzType]="uploadingCertificate ? 'loading' : 'upload'"
          ></span>
          העלאת תעודה
        </button>
      </nz-upload>
    </ng-template>
    <ng-template [authorityLabsHasPermission]="adminPermissions">
      <ng-template nzSpaceItem>
        <button
          *ngIf="canDeleteCertificate"
          nz-button
          nzType="primary"
          nzDanger
          (click)="deleteCertificate()"
        >
          <span nz-icon nzType="delete"></span>
          מחיקת תעודה
        </button>
      </ng-template>
    </ng-template>
    <ng-template nzSpaceItem></ng-template>
  </nz-space>

  <p class="warning" *ngIf="!isApproved" actions>
    * התעודה לא אושרה ולכן לא ניתן להפיק אותה כרגע
  </p>
</authority-labs-base-dialog>

<ng-template #orderVersionTemplate>
  <nz-radio-group [(ngModel)]="version">
    <label nz-radio *ngFor="let item of versions | slice : 1" [nzValue]="item">
      <span *ngIf="item"> {{ order.id }}-{{ item }} </span>
    </label>
    <label nz-radio [nzValue]="versions.length"
      >גרסא חדשה: {{ order.id }}-{{ versions.length }}</label
    >
  </nz-radio-group>
</ng-template>
